import React from 'react';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import './styles/ChooseWriting.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ChooseWriting = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { content } = location.state || {};

  const showContent = (file, translationFile) => {
    navigate('/test-writing', { state: {
      content: file.content,
      name: file.name,
      translation: translationFile.content,
    }});
  };

  const getContentByLanguage = (language) => {
    const languageObject = content.find((speak) => speak.name === language);
    return languageObject ? languageObject.content : null;
  };

  const getFileAtIndex = (speakingArray, index) => {
    return speakingArray[index];
  };

  const fi_speaking = getContentByLanguage('fi');
  const user_language_speaking = getContentByLanguage('en');

  return (
    <div className="container">
      <BackButton to="/writing" label={t('writing')} />
      <h2 className="page-title">{t('chooseContent')}</h2>
      <div className="content-list">
        {fi_speaking.map((file, index) => (
          <div
            key={index}
            className="content-list-item"
            onClick={() => showContent(file, getFileAtIndex(user_language_speaking, index))}
          >
            <div className="content-list-icon"><Icon name="document" size={20} color="var(--text-secondary)" /></div>
            <span className="content-list-text">{file.name}</span>
            <span className="content-list-arrow">&rsaquo;</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseWriting;
